import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { Menu, MenuItem } from "./navbar";

export function TreeMenu({
  pagesTree,
  className,
}: {
  pagesTree: MenuItem[];
  className?: string;
}) {
  return (
    <ul className={`flex flex-col ${className}`}>
      {pagesTree.map((page, index) => (
        <li key={`tree-menu-item-${index}`} className="w-full">
          {"separator" in page ? (
            <div className="h-[1px] w-full bg-gray-200" />
          ) : (
            <TreeMenuItem page={page} />
          )}
        </li>
      ))}
    </ul>
  );
}

function TreeMenuItem({ page, isChild }: { page: Menu; isChild?: boolean }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const hasChildren = page.children && page.children.length > 0;

  const className = `w-full flex items-center py-3 hover:bg-pink-600 text-white ${!isChild ? "font-bold" : ""} ${isActive(page.slug, location.pathname) ? "bg-pink-600" : ""}`;
  if (hasChildren) {
    return (
      <>
        <button
          className={`${className} min-w-[100px]`}
          onClick={() => setOpen(!open)}
        >
          <div className="w-[50px]">
            <FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} />
          </div>
          <div>{page.title}</div>
        </button>
        {open && (
          <ul>
            {page.children!.map((child, index) => (
              <li key={`tree-menu-item-${index}`}>
                {"separator" in child ? (
                  <div className="h-[1px] w-full bg-gray-200" />
                ) : (
                  <TreeMenuItem isChild={true} page={child} />
                )}
              </li>
            ))}
          </ul>
        )}
      </>
    );
  } else {
    return (
      <NavLink className={`${className} pl-[50px]`} to={page.slug}>
        {page.title}
      </NavLink>
    );
  }
}

function isActive(slug: string, pathname: string): boolean {
  return pathname.startsWith(slug);
}
